import { Link } from 'react-router-dom'

import { IconChatOutlineTransparentBg } from 'assets/svg/sprite'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { useModalContext } from 'context/modalContext'

import style from './_claimed_users_modal.module.scss'

export const ClaimedUsersModal = ({ users }: { users: [] }) => {
    const dateArray = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ]
    const modalData = useModalContext()

    return (
        <div className={style.container}>
            <div className={style.users_container}>
                {users.length > 0 &&
                    users.map((user: any, index) => {
                        const today = new Date()
                        const userJoin = user.join_date
                            ? new Date(user.join_date.replace(' ', '-'))
                            : new Date()
                        return (
                            <ActionCard
                                key={index}
                                text={user.name}
                                subtext={`@${user.username.toLowerCase()}`}
                                avatar={
                                    <div className={style.user_avatar}>
                                        <img
                                            src={user.avatar?.url}
                                            alt='avatar'
                                        />
                                    </div>
                                }
                                description={
                                    <div className={style.user_claimed}>
                                        Claimed{' '}
                                        <span>
                                            {today.toDateString() === userJoin.toDateString()
                                                ? 'Today'
                                                : `${
                                                    dateArray[userJoin.getMonth()]
                                                } ${userJoin.getDate()}, ${userJoin.getFullYear()}`}
                                        </span>
                                    </div>
                                }
                                customHtml={
                                    <Link
                                        to={`/chat/${user.id}`}
                                        state={{
                                            activePage: !user.conversation_id ? 'newmessage' : '',
                                            otherUserData: {
                                                ...user,
                                                display_name: user.name ?? '',
                                                username: user.username ?? '',
                                                avatar: user.avatar,
                                                croppedAvatar: user.croppedAvatar,
                                                isSubscribed: Boolean(user.isSubscribed)
                                            },
                                            ...(user.conversation_id
                                                ? { conversationId: user.conversation_id }
                                                : {})
                                        }}
                                        onClick={() => {
                                            modalData.clearModal()
                                        }}
                                    >
                                        <div className={style.user_chat_link}>
                                            <IconChatOutlineTransparentBg color='#2894ff' />
                                        </div>
                                    </Link>
                                }
                            />
                        )
                    })}
            </div>
        </div>
    )
}
